import React from "react";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import Button from "@mui/material/Button";
import Box from "@mui/material/Box";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import Tooltip from "@mui/material/Tooltip";
import ImageLoad from "@app.automotus.io/components/ImageLoad";

export interface ZoneReferenceImageDialogProps {
  open: boolean;
  onClose: () => void;
  cameraId: string;
}

interface LegendItem {
  color: string;
  label: string;
  description: string;
}

const legendItems: LegendItem[] = [
  { color: "#00FF00", label: "Parking", description: "Valid region for vehicles to stop" },
  { color: "#FF0000", label: "No Stopping", description: "Area where vehicles cannot legally stop" },
  { color: "#0000FF", label: "License Plate", description: "Region where license plates are captured" },
  { color: "#000000", label: "Entry/Exit", description: "Region where objects enter/exit the frame" },
];

export const ZoneReferenceImageDialog: React.FC<ZoneReferenceImageDialogProps> = ({ open, onClose, cameraId }) => {
  const imageUrl = `https://${process.env.REACT_APP_CDN_HOST}/cameras/${cameraId}/reference.jpg`;

  return (
    <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
      <DialogTitle>Zone Reference Image</DialogTitle>
      <DialogContent>
        <Box sx={{ mb: 2 }}>
          <Tooltip
            title="Regions are drawn twice to include a buffer that prevents premature exits from the region."
            arrow
          >
            <Box>
              <ImageLoad
                width="100%"
                height="auto"
                imageUrl={imageUrl}
                alt={`Zone reference image for camera ${cameraId}`}
              />
            </Box>
          </Tooltip>
        </Box>
        <Stack direction="row" spacing={3} sx={{ flexWrap: "wrap", justifyContent: "center" }}>
          {legendItems.map((item) => (
            <Tooltip key={item.label} title={item.description} arrow>
              <Stack direction="row" spacing={1} alignItems="center" sx={{ cursor: "pointer" }}>
                <Box
                  sx={{
                    width: 16,
                    height: 16,
                    backgroundColor: item.color,
                    borderRadius: 0.5,
                  }}
                />
                <Typography variant="body2">{item.label}</Typography>
              </Stack>
            </Tooltip>
          ))}
        </Stack>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Close</Button>
      </DialogActions>
    </Dialog>
  );
};

export default ZoneReferenceImageDialog;
